
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexqEJtpGC1YrLdr2l_oOvU77k2CBgqPIgNYt99APwohQMMeta } from "/codebuild/output/src2719559069/src/pages/index.vue?macro=true";
import { default as indexRBcoWSi8xzFjlPISd40jXqRpm_45X_YYPiWKC_45SRu0iSgMeta } from "/codebuild/output/src2719559069/src/pages/login/index.vue?macro=true";
import { default as index6vbl37H4Yl1vKyvNiB52TxKa4BXL0sQPRXcsmG8b5OYMeta } from "/codebuild/output/src2719559069/src/pages/software/index.vue?macro=true";
import { default as index6r9edVkufmrolMTeMJiPlKNtSeBAjIo3Jm4CsCBm9skMeta } from "/codebuild/output/src2719559069/src/pages/trackers/index.vue?macro=true";
import { default as indextXXi1dm_lM3Id7JwjxG04vwfjtIgXNhc66IWxZNnY_45YMeta } from "/codebuild/output/src2719559069/src/pages/templates/index.vue?macro=true";
import { default as createBL4PTguSwWM_CiFLiwlBU6i_45f70baqH3ANt9zjzj2BwMeta } from "/codebuild/output/src2719559069/src/pages/trackers/create.vue?macro=true";
import { default as createoTllLMNQgaq4erJlr_456bdCY_45tDr3akjlDomZbzYzXagMeta } from "/codebuild/output/src2719559069/src/pages/templates/create.vue?macro=true";
import { default as indexplv0kWDaOBJnbExtJeZkFvisNzY3mrivmSv3WdZO5_sMeta } from "/codebuild/output/src2719559069/src/pages/tagging-docs/index.vue?macro=true";
import { default as editu4QTTvTo4iMsMuNC_4KJXrBVMTAUzmxZmnrq8aloQy8Meta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_93IL6vHjmgWe5GSwNxrOW7uYSg0WKDrEt7HiNea9iry7wMeta } from "/codebuild/output/src2719559069/src/pages/login/token/[token].vue?macro=true";
import { default as editiXWNrvCij6CC1wMUNlqQ9_45uCZweqrURTvzln7e0SID0Meta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/edit.vue?macro=true";
import { default as indexq_gwx6JcEDaO1or1y2glsYqC7M8hq2uQlzP0v4czXOsMeta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/index.vue?macro=true";
import { default as indexMjZitlSgIevuB2TNWYQWqrdAj0QDTROgUBJDSHFntEsMeta } from "/codebuild/output/src2719559069/src/pages/plan-management/index.vue?macro=true";
import { default as index_GDegkI7JDmYXxYIwYF75O7VdP9COhLAXPWHznmlKkcMeta } from "/codebuild/output/src2719559069/src/pages/dropcode-generator/index.vue?macro=true";
import { default as indexIrE4qtV9yBZMt_45JKTaqporp_45vdcc9CWiU_4545wGAupXAMeta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as indexxPBfl5avxIb13srTCtbn9jp1xBQgNEtNTwnw1GZHmqcMeta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as indexMPuV9CShAu_PY9tVTNur6IPZHgdVMhbe126TBiCXyx4Meta } from "/codebuild/output/src2719559069/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as createzD0_xxjtWDql23pL7LlgodOMsATmtW6bh63ZrZbJ5lwMeta } from "/codebuild/output/src2719559069/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as editneP38FCDtmWHiBQ2dOTny_45zyLo3R5qAeFl81WdIt740Meta } from "/codebuild/output/src2719559069/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsfuqE3M4TUzu4jJCZBweO9lOUyGoR_457gTjwHn3r7fajAMeta } from "/codebuild/output/src2719559069/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as indexRPlMOAoN14ksZZtCmcttEAym3Ce_vUOHDP8duvy5al0Meta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as createWUhhYazvligI8R5h7C1V_iUdonRQc3lgCVl3Ca0w1HYMeta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groupsc9ML9aAePO6In4EWL2anKFECxVpK8WevW0mNWrPj2jwMeta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as createav5iNyX9nx1Y6cEIoR5X5gveNCl_5V1KyZUnyMwMcmYMeta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as indexCkhxTJqd00pb7nZevzWqo7BSkmBE2Qt4fsId8JokLIEMeta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexX4hYB3kBDEy05Oit1_45gUJEvI1fwHqtss2aQKkeGeuHMMeta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as createG6PdOW0k4EWHLZw2xmNk6PkBM6tg8f2ZNthV1LyFwekMeta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backendrpv8_6h9E4xNqKUEn9K57zuUeiUCdLwyPy_45ruxesnSsMeta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as createeE8d_HJsKTapAcn71jGWm8nMTZ_A_45bKDOdsLdptzlx0Meta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontend9d6kg7_EqziQYiN5ufbohq6pNOepJRsOk5C9HBpWca8Meta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePage7UoAKLBb8A2i4YaPyjlPOfaw82aR_45sxIP2lLvmiTRAIMeta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as indexY3UjMIRfY2gQNFk8O9pGj9Ruvf6XHEPAQDJFBOnLM4MMeta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as indexG7hOIl5asCX6vkiP6XSJvdsusec1qUiscJvsl_Q9j34Meta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownershiplw7qB8FyfJ_45MsNoWZAl18bNTQr1_q75NyUQNIYkV1WoMeta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as index9weXUgefxgClePqbULRgDbKz49J8dEd4aoa7CpUUOb4Meta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as indexMC6I98I8WtDF0FLaQXcQJcA2r1q5OT7szI6OvtbYltQMeta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontendLy4gPBE_45CJZwsn7VJvlZA1aIOljfCTZ3ekEV4XxVnogMeta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v2EaRTq_Uj_45urTctIROFR0CwuGBansHDgdBhoqLrn5oicMeta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as edit28fgm53CYI1zCXHT8ikRouoxHGcT4sD95dpFbdVqUtYMeta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as edit2BOwg9QubkJIbIUynV23lawhugmNH6b6kFNgseij_45Y0Meta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45componentsvpQVUBGpCSI6snuu9AW5mQTMQzjkYDHD1GhV9W6ZJIcMeta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45salesf_OkoFhCu5jm2gL_45xYFzFCZX2xUAJ6zDjO5x5dwpaFcMeta } from "/codebuild/output/src2719559069/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as indexTaLCsy3M0UPNDMQpKN7hcjwhPZAOG_45GUNbdTOZWeBG8Meta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexyPx46RUQAiHhQkFDQNty5xBX5VtP91k_ZkV2DoICNtAMeta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as createo6ghN71pQy8cGm_3G_YhiPUuVKW4iwdh0as24J954J4Meta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as createGQH2FJJLWX_45WLBJdxCWB2sKIkeq7_45qj3WFGmh2g51VQMeta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as editYSO27fln38E12ztu0qOAwevIEhe2VSsX87gz_45WrY0RMMeta } from "/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editRIe4m2keXEOGRFDX7ppd2LIaPMPYjMO7_wSOgIOrVz0Meta } from "/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2719559069/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src2719559069/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src2719559069/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src2719559069/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src2719559069/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src2719559069/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src2719559069/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsfuqE3M4TUzu4jJCZBweO9lOUyGoR_457gTjwHn3r7fajAMeta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src2719559069/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src2719559069/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src2719559069/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src2719559069/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src2719559069/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]